module.exports = __webpack_public_path__ + "assets/media/expiration_error.6e945083.svg";